import { UPDATE } from 'react-admin';

export const ISSUE_TICKETS = 'ISSUE_TICKETS';
export const issueTickets = (id, data, basePath) => ({
    type: ISSUE_TICKETS,
    payload: { id, data: { ...data, tickets_issued: true } },
    meta: { fetch: UPDATE, resource: 'events' },
});